var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateTime)?_c('div',{attrs:{"id":"time-panel"}},[_c('div',[_vm._v("数据更新时间: "+_vm._s(_vm.time))]),_c('div',[_vm._v("当期本机时间: "+_vm._s(_vm.nowTime))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }